import _ from "lodash";
import config from "../config";

const dayjs = require("dayjs");

const getToday = () => {
  return dayjs().format("YYYY-MM-DD HH:mm:ss");
  // return dayjs().toISOString();
};

const getTomorrow = () => {
  return dayjs().add(1, "day").format("YYYY-MM-DD HH:mm:ss");
};

const getYesterday = () => {
  return dayjs().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss");
  // return dayjs().subtract(1, "day").toISOString();
};

const getBeforeSevenDay = () => {
  return dayjs().subtract(7, "day").format("YYYY-MM-DD HH:mm:ss");
};

const getLastMonth = () => {
  return dayjs().subtract(1, "month").format("YYYY-MM-DD HH:mm:ss");
};

const compareFn = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

const parseFullNameFromUser = (user) => {
  return `${user.name} ${user.lastname}`;
};

const parseStatus = (status) => {
  let statusText;
  if (status === "1") {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        รอการดำเนินการตรวจสอบ
      </div>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`rounded-lg w-max border border-green-500 px-2 py-1 text-xs text-green-500`}
      >
        ผ่านการตรวจสอบ
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`rounded-lg w-max border border-red-500 px-2 py-1 text-xs text-red-500`}
      >
        ไม่ผ่านการตรวจสอบ
      </span>
    );
  } else if (status === "4") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการอนุมัติ
      </span>
    );
  } else if (status === "5") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการอนุมัติ
      </span>
    );
  }
  //  else if (status === "6") {
  //   statusText = (
  //     <span
  //       className={`rounded-lg max-w-max border border-orange-500 px-2 py-1 text-xs text-orange-500`}
  //     >
  //       รอการแก้ไข
  //     </span>
  //   );
  // } else if (status === "7") {
  //   statusText = (
  //     <span
  //       className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
  //     >
  //       แก้ไขสำเร็จ
  //     </span>
  //   );
  // }
  else {
    statusText = "Invalid status";
  }
  return statusText;
};

const parseStatusRevise = (status) => {
  let statusText;
  if (status === "1") {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        รอการดำเนินการตรวจสอบ
      </div>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการตรวจสอบจาก Checker
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการตรวจสอบจาก
      </span>
    );
  } else if (status === "4") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-green-600 px-2 py-1 text-xs text-white`}
      >
        ผ่านการตรวจสอบจาก
      </span>
    );
  } else if (status === "5") {
    statusText = (
      <span
        className={`rounded-lg w-max bg-red-500 px-2 py-1 text-xs text-white`}
      >
        ไม่ผ่านการตรวจสอบจาก
      </span>
    );
  } else {
    statusText = "Invalid status";
  }
  return statusText;
};

const statusRevise = (status) => {
  let statusText;
  if (status === "0") {
    statusText = "";
  } else if (status === "1") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-green-600 px-2 py-1 text-xs text-green-600`}
      >
        เพิ่ม
      </span>
    );
  } else if (status === "2") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-yellow-500 px-2 py-1 text-xs text-yellow-500`}
      >
        แก้ไข
      </span>
    );
  } else if (status === "3") {
    statusText = (
      <span
        className={`ml-2 rounded-lg max-w-max border border-red-500 px-2 py-1 text-xs text-red-500`}
      >
        ลบ
      </span>
    );
  } else {
    statusText = "";
  }
  return statusText;
};

const sortData = (data, field) => {
  return data;
  const cloneData = _.cloneDeep(data);
  cloneData.sort(function (a, b) {
    let numA = parseInt(a[field].match(/\d+/));
    let numB = parseInt(b[field].match(/\d+/));
    if (!isNaN(numA) && !isNaN(numB)) {
      if (numA !== numB) {
        return numA - numB;
      }
    }
    return a[field].localeCompare(b[field]);
  });
  return cloneData;
};

const statusPartSuccess = (status) => {
  let statusText;
  if (status === true) {
    statusText = (
      <div
        className={`rounded-lg max-w-max border border-blue-500 px-2 py-1 text-xs text-blue-500`}
      >
        เพิ่มข้อูล part สำเร็จ
      </div>
    );
  } else if (status === false) {
    statusText = (
      <span
        className={`rounded-lg w-max border border-green-500 px-2 py-1 text-xs text-green-500`}
      >
        เพิ่มข้อูล part ไม่สำเร็จ
      </span>
    );
  } else {
    statusText = "Invalid status";
  }
  return statusText;
};

const scrollToRef = (ref) => {
  if (ref) {
    setTimeout(() => {
      ref.scrollIntoView({ behavior: "auto" });
    }, 100);
  }
};

const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const sortSignature = (signature) => {
  return signature.sort((a, b) =>
    dayjs(a.createdAt).isAfter(dayjs(b.createdAt), "minute")
      ? -1
      : dayjs(a.createdAt).isBefore(dayjs(b.createdAt), "minute")
      ? 1
      : 0
  );
};

const exportDataAll = (paper) => {
  //console.log("PAPER DATA >>",paper);
  let dataExport;
  // console.log("Question Create", paper[0].createdAt);
  const data = paper[0];
  /* console.log("First entry", data);
  console.log("Part Name", data?.partName);
  console.log("Questions", data?.answer?.sub_categories?.[0]?.questions);
  console.log("All data about revise", data?.partName?.revise?.revisionRecord); */
  const partData = data?.partName;
  if (!partData) {
    console.error("Part data is missing or incomplete.");
    return null;
  }

  const partName = partData?.part_name;
  const imagePart = partData?.image?.url;

  if (!partData) {
    console.error("Part data is missing or incomplete.");
    return null; // Exit if critical part data is missing
  }

  if (!paper || !paper.length) {
    console.error("No paper data available.");
    return null;
  }
  try {
    // const purchaseNumber = paper[0]?.partName.purchase_no;
    const documentNumber = paper[0]?.partName.document_no;
    const partCode = partData?.part_code;
    const sampleNumber = paper[0]?.sampleNumber;
    const purchaseNumber = paper[0]?.purchaseNumber;
    // const rank = paper[0]?.rank;
    const partAmount = paper[0]?.partAmount;
    const inspectionTool = paper?.answer?.sub_categories.map(
      (e) => e.questions
    );
    const vernierNo = paper[0]?.vernierNo || "";
    const model = paper[0]?.model || "";
    const customer = paper[0]?.customer || "";
    const supplier = paper[0]?.supplier || "";
    const dateCreated = dayjs(paper[0]?.createdAt).format("DD-MM-YYYY") || "";

    const currentRev = {
      rev: paper[0]?.partName?.revise_time || "-",
      description: paper[0]?.partName?.revise?.revisionRecord || "-",
      date: paper[0]?.partName?.revise?.createdAt
        ? dayjs(paper[0].partName.revise.createdAt).format("DD/MM/YYYY")
        : "-",
    };

    const oldParts = paper[0]?.partName?.old_parts || [];
    const sortedOldParts = [...oldParts]
      .filter((p) => p?.revise)
      .sort((a, b) =>
        dayjs(b.revise?.createdAt).isAfter(dayjs(a.revise?.createdAt)) ? 1 : -1
      );

    const previousRevs = sortedOldParts.slice(0, 2).map((old) => ({
      rev: old?.revise?.revise || "-",
      description: old?.revise?.revisionRecord || "-",
      date: old?.revise?.createdAt
        ? dayjs(old.revise.createdAt).format("DD/MM/YYYY")
        : "-",
    }));

    const revisionRecord = [currentRev, ...previousRevs];
    const publishedAtRaw = paper[0]?.publishedAt;
    const publishedAt = publishedAtRaw ? dayjs(publishedAtRaw).format("DD/MM/YYYY") : "";
    console.log("Published At", publishedAt);

    
    let dataQuestion = [];
    // console.log("Part Data:", data);

    data.answer.sub_categories.forEach((subCat) => {
      subCat.questions.forEach((question) => {
        dataQuestion.push({
          spec_min: question.spec_min,
          spec_max: question.spec_max,
          inspectionTool: question.inspectionTool,
          checkPoint: question.questionName,
          answer1: question.answer.filter((e) => e != ""),
          answer2: question.answer.filter((e) => e != ""),
          answer3: question.answer.filter((e) => e != ""),
          actual1: question.actual.filter((e) => e != ""),
          actual2: question.actual.filter((e) => e != ""),
          actual3: question.actual.filter((e) => e != ""),
          comment1: question.comment.filter((e) => e != ""),
          comment2: question.comment.filter((e) => e != ""),
          comment3: question.comment.filter((e) => e != ""),
          typeCheck: subCat.category,
          revise_time: question.revise_time,
          lastRevise: partData.revise_time === question.revise_time,
          sub_category: subCat.sub_category,
        });
      });
    });

    dataExport = {
      dataquestion: dataQuestion || "",
      date: paper[0].date || "",
      time: paper[0].time || "",
      dateCreated: dateCreated || "",
      // shift: shift,
      // process_status: process_status,
      partName: partName || "",
      partCode: partCode || "",
      // purchaseNumber: purchaseNumber || "",
      reviseNo: paper[0]?.partName.revise_time || "0",
      documentNumber: documentNumber || "",
      sampleNumber: sampleNumber || "",
      purchaseNumber: purchaseNumber || "",
      inspectionTool: inspectionTool || "",
      vernierNo: vernierNo || "",
      partAmount: partAmount || "",
      model: model || "",
      customer: customer || "",
      supplier: supplier || "",
      imagePart: imagePart || "",
      signature_approver:
        paper[0].signature_approver && paper[0].signature_approver,
      signature_checker:
        paper[0].signature_checker && paper[0].signature_checker,
      signature_inspector:
        paper[0].signature_inspector && paper[0].signature_inspector,
      revisionRecord: revisionRecord || "",
      publishedAt: publishedAt || "",

    };

    return dataExport;
  } catch (e) {
    console.log(e);
  }
};

export {
  getToday,
  getTomorrow,
  getYesterday,
  parseFullNameFromUser,
  parseStatus,
  getBeforeSevenDay,
  getLastMonth,
  parseStatusRevise,
  statusRevise,
  sortData,
  statusPartSuccess,
  scrollToRef,
  getBase64,
  sortSignature,
  exportDataAll,
};
